// Action Types for Redux Reducers

export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_GROUP_ROLE = 'SET_GROUP_ROLE';
export const SET_USERS_FILTER = 'SET_USERS_FILTER';
export const CLEAR_USER_FILTER = 'CLEAR_USER_FILTER';
export const SET_USER_ROLE_FILTER = 'SET_USER_ROLE_FILTER';
